import { useRouter } from "next/router"
import { useEffect, useState } from "react"
import { Autocomplete, Loader, Stack } from "@octopus-energy/coral/atoms"
import { fetchSbStories } from "../../lib/api"
import { type SbStoriesParams } from "../../types"

interface StoryblokSearchBarProps {
    searchParams: SbStoriesParams
}

export function StoryblokSearchBar({ searchParams }: StoryblokSearchBarProps) {
    const [isLoading, setIsLoading] = useState(false) // Also prevents from typing while loading selected story + Hack to force Coral's async re-render of options
    // const [value, setValue] = useState("")
    const value = ""
    const [options, setOptions] = useState<{ label: string; value: string }[]>([])
    const router = useRouter()

    useEffect(() => {
        const fetchStories = async () => {
            // TODO remove this useEffect
            // Load all stories while Coral is working on allowing async Autocomplete
            const stories = await fetchSbStories({ ...searchParams })

            const autocompleteOptions = stories.map((s) => ({ label: s.name, value: s.full_slug }))
            setOptions(autocompleteOptions)
        }

        void fetchStories()
    }, [searchParams])

    // const fetchStories = debounce(async (search) => {
    //     setIsLoading(true)
    //     setValue(search)
    //     const normalizedSearch = search.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    //     const parsedSearch = normalizedSearch
    //         .split(" ")
    //         .map((term) => `*${term}*`)
    //         .join(",")
    //     const params = { by_slugs: parsedSearch, ...searchParams }
    //     const stories = await fetchSbStories(params)
    //     setStories(stories)
    //
    //     const autocompleteOptions = stories.map((s) => s.name)
    //     setOptions(autocompleteOptions)
    //     setIsLoading(false)
    // }, 800)

    const goToStory = async (slug: string | null) => {
        setIsLoading(true)

        await router.push(`/${slug}`)
    }

    // const onBlur = (value) => {
    //     if (!value) {
    //         setOptions([]) // Prevents confusing situation of having no search term in the input while keeping the previous macthing options
    //     }
    // }

    // const onInputChange = (value) => {
    //     fetchStories(value)
    // }

    if (isLoading) {
        return (
            <Stack justifyContent="center">
                <Loader />
            </Stack>
        )
    }

    return (
        <Autocomplete
            noDataLabel="Aucun résultat"
            label="Rechercher"
            value={value}
            options={options}
            // onInputChange={(value) => onInputChange(value)} TODO when Coral accepts async loading, enable back fetching procedure
            onChange={(_label, value) => goToStory(value)}
            // onBlur={(value) => onBlur(value)} TODO when Coral accepts async loading, enable back onBlur
        />
    )
}
